
import { 
  SenseFeature
} from "@dndModels";

/**
 * 
 */
export class CharacterSense {
  sense_id: string;
  range: number;
  name: string;
  features: SenseFeature[];

  constructor(obj?: any) {
    this.sense_id = obj ? obj.sense_id : "";
    this.range = obj ? obj.range : 0;
    this.name = obj ? obj.name : "";
    this.features = obj && obj.features ? obj.features : [];
  }

  toDBObj(): any {
    return {
      sense_id: this.sense_id,
      range: this.range,
      name: this.name
    };
  }

  clone() {
    const new_obj = new CharacterSense();
    new_obj.copy(this);
    return new_obj;
  }

  copy(copyMe: CharacterSense) {
    this.sense_id = copyMe.sense_id;
    this.range = copyMe.range;
    this.name = copyMe.name;
    this.features = [...copyMe.features];
  }
}